import AnalyticsProvider from './AnalyticsProvider'
import {Datalayer} from '../index'
import Status from '../status/Status'
import {initEventHub} from '../eventhub/EventHub'

declare global {
  interface Window {
    analytics:
      | {
          track: (
            event: string,
            property: string | Record<string, unknown>,
            callback?: () => void,
          ) => void
          page: (parameters?: Record<string, unknown>) => void
          identify: (id: string) => void
        }
      | undefined
    define: unknown
  }
}

export default class EventHub implements AnalyticsProvider {
  isActive = false

  private _url: string
  private _key: string
  private _endpoint: string
  private _events: Datalayer[] = []

  constructor(url: string, key: string, endpoint: string, isActive = false) {
    this._url = url
    this._key = key
    this._endpoint = endpoint

    this.isActive = isActive
  }

  init(): Promise<Status> {
    return new Promise<Status>((resolve, reject) => {
      initEventHub({
        apiHost: `${this._endpoint}/v1`,
        apiKey: this._key,
      })

      resolve(new Status(this, true))
    })
  }

  sendEvent(data: Datalayer): Promise<Status> {
    return new Promise((resolve, reject) => {
      if (typeof window.analytics !== 'undefined') {
        window.analytics.track(data.event, data.property)

        setTimeout(() => {
          resolve(new Status(this, true))
        }, 100)
      }
    })
  }

  get url(): string {
    return this._url
  }

  set url(value: string) {
    this._url = value
  }

  get key(): string {
    return this._key
  }

  set key(value: string) {
    this._key = value
  }

  get endpoint(): string {
    return this._endpoint
  }

  set endpoint(value: string) {
    this._endpoint = value
  }

  get events(): Datalayer[] {
    return this._events
  }

  set events(value: Datalayer[]) {
    this._events = value
  }
}
